$(() => {

    (function ajaxHandlers() {
        $(window).on('init.rangeSlider', function () {
            $(window).trigger('initRangeSlider');
        });
        $(window).on('init.scrollables', function () {
            $(window).trigger('initScrollables')
        });
    })();

    (function setLinksTargetBlank() {
        $(window).on('init.linksTarget', () => {
            $('a:not([target])').each((i, item) => {
                const $item = $(item);
                const href = $item.prop('href');

                if (href.indexOf(location.origin) !== 0 && href.indexOf('http') === 0) {
                    $item.attr('target', '_blank');
                    console.log('blank!', href);
                }
            });
        });
        $(window).trigger('init.linksTarget');
    })();

    (function buttonLoadingAnimation() {
        $(document)
            .on('button:loadingStart', 'button,a', (event) => {
                $(event.currentTarget).addClass('active');
            })
            .on('button:loadingEnd', 'button,a', (event) => {
                $(event.currentTarget).removeClass('active');
            });
    })();

    (function preloaderShowHide() {
        $(window).on('preloader:show', function () {
            BX.showWait();
        });

        $(window).on('preloader:hide', function () {
            BX.closeWait();
        });
    })();

});